<script setup lang="ts">

import { watch } from "vue";
import { usePresentation } from '@/modules/Presentation/Types';
import { useLead } from "../../Types/Lead";
import { useForm, Form } from "@library/Components/Forms/Form/v2";
import { LeadOptions, LeadType } from '../../Types/LeadOptions';

import SelectOption from "../../Components/SelectOption.vue";

const lead = useLead();
const form = await useForm( lead );
const presentation = usePresentation();
presentation.backgroundImage = '/images/sample/gkr-watermark.png';

presentation.canProceed = () => {
    return lead.leadType != null
        && lead.ageGroup != null
        && lead.gender != null
}

watch( () => lead.leadType, v => {
    lead.ageGroup = undefined;
    lead.gender = undefined;
});

</script>

<template>

    <Page>

        <div class="flex flex-col gap-4 w-full">

            <p class="text-xl font-semibold mb-4">
                Are you considering Karate for yourself or somone else?
            </p>

            <Form 
                :form="form"
                v-slot="{ model, state }"
                class="flex flex-col gap-8">

                <SelectOption 
                    title="Who is interested?"
                    v-model="model.leadType" 
                    :options="LeadOptions.leadType"               
                />

                <div v-if="model.leadType != null"
                    class="flex flex-col gap-8 mt-4">
                
                    <p class="mt-6 text-xl font-semibold">
                        A little more about 
                        <span v-if="lead.leadType == LeadType.family">those that are interested</span>
                        <span v-else>the person that is interested</span>
                    </p>

                    <SelectOption 
                        title="Age Group"
                        v-model="model.ageGroup" 
                        :multiple="model.leadType == LeadType.family"
                        :options="LeadOptions.ageGroup"               
                    />

                    <SelectOption 
                        title="Gender"
                        v-model="model.gender" 
                        :multiple="model.leadType == LeadType.family"
                        :options="LeadOptions.gender"               
                    />

                </div>

            </Form>
            
        </div>
    </Page>
    
</template>